'use strict';

var RomAnalysisConfig = function RomAnalysisConfig($stateProvider) {
  $stateProvider.state('app.rom-analysis', {
    url: '/workflow/rom-analysis',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/rom-analysis-panel.html'),
        controller: 'RomAnalysisController'
      },
      'mainToolbar': {
        template: require('../templates/rom-analysis-toolbar.html'),
        controller: 'RomAnalysisToolbarController'
      }
    }
  });
};
RomAnalysisConfig.$inject = ['$stateProvider'];
module.exports = RomAnalysisConfig;